import axios from '@/plugins/http/axios.js';
import config from "@/views/tips-categories/config/tips_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getTips: (idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri()}categories`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      }
    });
  },
  createTip: (idEmpresa, idUsuario, data) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri()}categories`,
      headers: {
        'Content-Type': 'application/json',
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      data: data,
      redirect: 'follow'
    });
  },
  updateTip: (idEmpresa, idUsuario, tipId, data) => {
    return axios({
      method: 'put',
      url: `${config.baseUrl + _pathUri.generateUri()}categories/${tipId}`,
      headers: {
        'Content-Type': 'application/json',
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      data: data,
      redirect: 'follow'
    });
  },
  deleteTip: (idEmpresa, idUsuario, tipId) => {
    return axios({
      method: 'delete',
      url: `${config.baseUrl + _pathUri.generateUri()}categories/${tipId}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      redirect: 'follow'
    });
  }
};
